import { NgModule } from '@angular/core';

import { TransformSportToIconNamePipe } from './sport-to-icon-name.pipe';

@NgModule({
    declarations: [
        TransformSportToIconNamePipe
    ],
    exports: [
        TransformSportToIconNamePipe
    ]
})
export class TransformSportIconModule {}
